import { keyPathMirror } from 'key-path-mirror';

import { LocalesKey } from '../localesKeysTypes';

interface CategoriesKeyType {
  add: LocalesKey;
  change: LocalesKey;
  plural: LocalesKey;
  pluralLowerCase: LocalesKey;
  singular: LocalesKey;
  search: LocalesKey;
  seeAll: LocalesKey;
  seeLess: LocalesKey;
  styles: {
    plural: LocalesKey;
    singular: LocalesKey;
  };
  gammas: {
    singular: LocalesKey;
  };
  tones: {
    singular: LocalesKey;
  };
  materials: {
    plural: LocalesKey;
    singular: LocalesKey;
    search: LocalesKey;
  };
  brands: {
    plural: LocalesKey;
    search: LocalesKey;
    singular: LocalesKey;
  };
  authors: {
    plural: LocalesKey;
    singular: LocalesKey;
    search: LocalesKey;
  };
  colors: {
    plural: LocalesKey;
    singular: LocalesKey;
  };
  mainColors: {
    plural: LocalesKey;
  };
  accentColors: {
    plural: LocalesKey;
  };
  fileVersionTags: {
    plural: LocalesKey;
  };
  renderTypes: {
    plural: LocalesKey;
  };
  renderer: LocalesKey;
  mistakeTypes: {
    plural: LocalesKey;
  };
  collections: {
    plural: LocalesKey;
  };
  statuses: {
    plural: LocalesKey;
  };
  client: {
    select: LocalesKey;
  };
  marketingSource: LocalesKey;
  coldSource: LocalesKey;
  type: LocalesKey;
  seasonal: LocalesKey;
  feature: LocalesKey;
  room: LocalesKey;
}

export const categoriesKeys = keyPathMirror<CategoriesKeyType, string>(
  {
    add: null,
    change: null,
    plural: null,
    pluralLowerCase: null,
    singular: null,
    search: null,
    seeAll: null,
    seeLess: null,
    styles: {
      plural: null,
      singular: null
    },
    gammas: {
      singular: null
    },
    tones: {
      singular: null
    },
    materials: {
      plural: null,
      singular: null,
      search: null
    },
    brands: {
      plural: null,
      search: null,
      singular: null
    },
    authors: {
      plural: null,
      singular: null,
      search: null
    },
    colors: {
      plural: null,
      singular: null
    },
    mainColors: {
      plural: null
    },
    accentColors: {
      plural: null
    },
    fileVersionTags: {
      plural: null
    },
    renderTypes: {
      plural: null
    },
    renderer: null,
    mistakeTypes: {
      plural: null
    },
    collections: {
      plural: null
    },
    statuses: {
      plural: null
    },
    client: {
      select: null
    },
    coldSource: null,
    marketingSource: null,
    type: null,
    seasonal: null,
    feature: null,
    room: null
  },
  'models.categories.'
);
